import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LogoutPageComponent } from './shared/components/pages/logout-page.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'vendor',
    pathMatch: 'full',
  },
  {
    path: 'vendor',
    loadChildren: () =>
      import('./vendor/vendor.routes').then((r) => r.vendorRoutes),
    canActivateChild: [MsalGuard],
  },
  {
    path: 'member',
    loadChildren: () =>
      import('./member/member.routes').then((r) => r.memberRoutes),
    canActivateChild: [MsalGuard],
  },
  {
    path: 'vmx',
    loadChildren: () => import('./vmx/vmx.routes').then((r) => r.vmxRoutes),
    canActivateChild: [MsalGuard],
  },
  {
    path: 'vendor-terms',
    loadChildren: () =>
      import('./vendor-terms/vendor-terms.routes').then(
        (r) => r.vendorTermsRoutes
      ),
    canActivateChild: [MsalGuard],
  },
  {
    path: 'logout',
    component: LogoutPageComponent,
  },
  {
    path: '401',
    component: NotAuthorizedComponent,
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
